<script lang="ts" setup>
import SocialListItem from "@/components/mobile/SocialListItem.vue";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { useAdmire } from "@/stores/admire";
import { useMateCommit } from "@/stores/mateCommit";
import { showConfirmDialog, showLoadingToast } from "vant";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

// 状态
const router = useRouter();
const { t } = useI18n();
const admireStore = useAdmire();
const isLoading = ref(false);
const commitStore = useMateCommit();

onMounted(async () => {
  isLoading.value = true;
  try {
    await admireStore.fetchAdmiringList();
  } finally {
    isLoading.value = false;
  }
});

const onDeleteFriend = async (id: number) => {
  try {
    await showConfirmDialog({
      title: t("Social.actions.deleteFriend"),
      message: t("Social.actions.deleteFriendConfirm"),
      confirmButtonText: t("Buttons.confirm"),
      cancelButtonText: t("Buttons.cancel"),
    });
    const loading = showLoadingToast("");
    try {
      await admireStore.cancelAdmire(id);
    } finally {
      loading.close();
    }
  } catch (error) {
    // ignore
  }
};
// Lifecycle
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr] overflow-hidden">
    <threads-nav show-back>
      <template #center>
        <div class="font-bold">
          {{ $t("Titles.friends") }}
        </div>
      </template>
      <template #right>
        <div class="indicator">
          <span
            class="indicator-item badge badge-primary rounded-full badge-xs text-primary-content p-0 w-5 h-5 right-2 top-1"
            v-if="commitStore.pendingCount"
          >
            {{ commitStore.pendingCount }}
          </span>
          <RouterLink
            :to="{ name: 'requestList' }"
            class="btn btn-ghost btn-sm"
          >
            {{ $t("Buttons.applyList") }}
          </RouterLink>
        </div>
      </template>
    </threads-nav>
    <div class="w-full overflow-hidden">
      <ThreadList
        :on-pull-load="admireStore.fetchAdmiringList"
        :enable-scroll-load="false"
      >
        <div
          v-if="isLoading"
          class="h-[200px] flex items-center justify-center"
        >
          <span class="loading"></span>
        </div>
        <div
          v-else-if="admireStore.admiring.list.length > 0"
          class="flex flex-col w-full"
        >
          <social-list-item
            v-for="item in admireStore.admiring.list"
            :key="item.id"
            :id="item.id!"
            v-nsfw="item.mate.isNsfw"
            :avatar-url="item.mate.mediaUrl"
            :content="item.mate.bio"
            :gender="item.mate.gender"
            :mate-id="item.mateId"
            :name="item.mate.name"
            :type="item.mate.type"
            class="relative cursor-pointer"
            @click="
              router.push({
                name: 'mateHome',
                params: { uuid: item.mate.uuid },
              })
            "
          >
            <button
              class="btn btn-xs self-stretch rounded btn-error btn-outline"
              @click.stop="onDeleteFriend(item.id!)"
            >
              <i class="iconify mingcute--delete-2-line"></i>
            </button>
          </social-list-item>
        </div>
        <div
          v-else-if="isLoading"
          class="h-[200px] flex items-center justify-center"
        >
          <span class="loading"></span>
        </div>
        <div v-else class="flex flex-col items-center justify-center h-[200px]">
          <EmptyContent
            :title="$t('Empty.friendList.title')"
            :desc="$t('Empty.friendList.desc')"
          />
        </div>
      </ThreadList>
    </div>
  </div>
</template>
